/**
 * Incident Error Type Service
 * HTTP operations for incident error type catalog
 */

import { apiClient, API_CONFIG } from '@/api/core';
import type { ApiResponse } from '@/api/shared';
import type { LC_GetIncidentErrorTypesOut, IncidentErrorType } from './incidentType.types';
import { mapIncidentErrorTypes } from './incidentType.mapper';

/**
 * Service class for incident error type catalog operations
 */
export class IncidentErrorTypeService {
  /**
   * Get incident error types
   * GET /v{version}/catalog/incidentErrorTypes
   */
  async getIncidentErrorTypes(signal?: AbortSignal): Promise<ApiResponse<IncidentErrorType[]>> {
    const endpoint = API_CONFIG.ENDPOINTS.CATALOG.INCIDENT_ERROR_TYPES;
    const response = await apiClient.get<LC_GetIncidentErrorTypesOut>(endpoint, { signal });

    if (!response.success || !response.data) {
      return { ...response, data: null };
    }

    const types = mapIncidentErrorTypes(response.data);
    return { ...response, data: types };
  }
}

export const incidentErrorTypeService = new IncidentErrorTypeService();
